"use client";

// The one client boundary the treatment cards need.
//
// Booking a treatment opens the floating cart's quick-actions panel (which is
// where ScheduleTreatment lives) by dispatching a window event. That needs a
// handler, and a server component cannot pass a function to a client one — so
// the handler is encapsulated here and TreatmentCard stays a server component.
// Before this, the whole grid was 'use client' to support a modal.

import { Calendar } from "lucide-react";
import TrackedLink from "./TrackedLink";

export default function TreatmentBookButton({
  serviceId,
  serviceName,
  label,
  position = "card",
  size = "md",
  color = "base",
}: {
  serviceId: string;
  serviceName: string;
  label: string;
  position?: string;
  size?: "sm" | "md" | "lg";
  color?: "base" | "oat" | "neutral" | "duck";
}) {
  function openQuickActions() {
    try {
      if (typeof window === "undefined") return;
      (window as { dataLayer?: { push: (data: unknown) => void } }).dataLayer?.push({
        event: "open_quick_actions",
        from: "TreatmentCard",
        service_id: serviceId,
        service_name: serviceName,
      });
      window.dispatchEvent(
        new CustomEvent("floatingCart:openQuickActions", {
          detail: { from: "TreatmentCard", serviceId, serviceName },
        })
      );
    } catch {}
  }

  return (
    <TrackedLink
      onClick={openQuickActions}
      variant="solid"
      size={size}
      color={color}
      event="click"
      // Unchanged from the pre-refactor label so the existing series is continuous.
      label="Open Quick Actions (Treatment CTA)"
      component="TreatmentCard"
      meta={{ serviceId, serviceName, position }}
      className="inline-flex items-center gap-2"
    >
      <Calendar className="h-5 w-5" aria-hidden="true" />
      {label}
    </TrackedLink>
  );
}
